import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Announcement from "../../components/Home/Announcement";
import Jumbotron from "../../components/Home/Jumbotron";
import Shortcuts from "../../components/Home/Shortcuts";
import MonthControl from "../../components/Home/MonthControl";
import MonthSchedule from "../../components/Home/MonthSchedule";
import AlertService from "../../components/SweetAlert";
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import { config } from "../../config/index";
import "./styles.css";
const { API_URL } = config;

const Home = ({ client, sites }) => {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));
  const activeSite = localStorage.getItem("default_site_id")
    ? Number(localStorage.getItem("default_site_id"))
    : null;
  const token = localStorage.getItem("token")
    ? localStorage.getItem("token")
    : null;
  const [activeMonth, setActiveMonth] = useState({
    startDate: moment().startOf("month"),
    endDate: moment().endOf("month"),
  });
  const [defaultSiteData, setDefaultSiteData] = React.useState(null);
  const [selectedSiteId, setSelectedSiteId] = useState(activeSite);
  const [pendingSiteId, setPendingSiteId] = useState(activeSite);
  const [isEditingSite, setIsEditingSite] = useState(false);

  const submitRollCall = async (id, type) => {
    try {
      let response = await fetch(
        `${API_URL}/notification/associate/${user.id}/rollcall`,
        {
          method: "POST",
          body: JSON.stringify({ notification_id: id, type }),
          withCredentials: true,
          mode: "cors",
          headers: {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      );

      let responseData = await response.json();

      if (response.ok) {
        ToastUtil.success(responseData.message);
      } else {
        ToastUtil.error(responseData.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRollCalls = async () => {
    if (activeSite) {
      try {
        const url = `${API_URL}/associate/${user.id}/site/${activeSite}/rollcalls`;

        let response = await fetch(url, {
          mode: "cors",
          method: "GET",
          withCredentials: true,
          headers: {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json; charset=utf-8",
          },
        });

        let responseData = await response.json();

        if (response.ok) {
          let rollCallsData = responseData.data;

          for (const item of rollCallsData) {
            const rollcallsResult = await AlertService.reminder(
              "",
              item.message
            );

            if (rollcallsResult.isConfirmed) {
              await submitRollCall(item.id, "Acknowledge");
            } else {
              await submitRollCall(item.id, "Ignore");
            }
          }
        } else {
          console.log(response.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getNotificationMessage = async () => {
    return `
    <p style="text-align: left;padding-top: 20px;">Dear <span style="font-weight: 500;text-decoration: underline;">${
      user.first_name
    }</span>,</p>

    <p style="text-align: left;">ADDENDUM I TO MEMORANDUM OF TERMS OF EMPLOYMENT</p>

    <p style="text-align: left;">With reference to the Memorandum of Terms of Employment between Manpower Professional Singapore Pte Ltd (“Manpower”) and <span style="font-weight: 500;text-decoration: underline;">${
      user.first_name
    }</span>, NRIC/FIN Number: <span style="font-weight: 500;text-decoration: underline;">${
      user.nric || ""
    }</span> (“Contract Staff”) executed by Contract Staff on <span style="font-weight: 500;text-decoration: underline;">${
      moment(user.schedule_a_date).isValid()
        ? moment(user.schedule_a_date).format("D MMMM YYYY")
        : ""
    }</span> (“Memorandum”), parties now agree to enter into this Addendum I.</p>

    <p style="text-align: left;">1.This Addendum I to Memorandum shall be effective on the date of its execution by Contract Staff.</p>

    <p style="text-align: left;">2.Memorandum is amended as follows:</p>

    <p style="text-align: left;">a.“Mobile Phone Reimbursement” shall be amended and replaced with the following:</p>

    <p style="text-align: left;">“Mobile Phone Allowance:You are entitled to mobile phone allowance of S$50.00 per month. The mobile phone allowance will be pro-rated for any incomplete month of service and is calculated in direct proportion to the total number of working days in that month.”</p>

    <p style="text-align: left;">3.The following provisions apply to and comprise Memorandum: (a)The contents of this Addendum I; and (b)Memorandum of Terms of Employment executed by Contract Staff on <span style="font-weight: 500;text-decoration: underline;">${
      moment(user.schedule_a_date).isValid()
        ? moment(user.schedule_a_date).format("D MMMM YYYY")
        : ""
    }
    </span>. In the event of any conflict between or among these documents, the above order of precedence shall apply, but only where a document explicitly deviates from or adds to a lower ranked document. No other terms or conditions of Memorandum shall be negated or changed as a result of this Addendum I.</p>

    <p style="text-align: left;">4.This Addendum I shall be governed by and construed in accordance with the laws of Singapore.</p>

    </br><p style="text-align: left;">Yours sincerely,
    </br>Doreen Goh Soh Huang (R1114537)
    </br>Senior HR Manager</p>`;
  };

  const fetchScheduledNotification = async () => {
    try {
      const url = `${API_URL}/associate/${user.id}/schedule-notification`;

      let response = await fetch(url, {
        mode: "cors",
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json; charset=utf-8",
        },
      });

      let responseData = await response.json();

      if (response.ok) {
        let data = responseData.data;
        let message = await getNotificationMessage();
        if (data.notify_associate) {
          const rollcallsResult = await AlertService.scheduleReminder(
            "",
            message
          );

          if (rollcallsResult.isConfirmed) {
            await submitAcknowledge("Acknowledge", message);
          }
        }
      } else {
        console.log(response.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const submitAcknowledge = async (status, message) => {
    try {
      let response = await fetch(
        `${API_URL}/associate/${user.id}/schedule-acknowledge`,
        {
          method: "POST",
          body: JSON.stringify({ status, message }),
          withCredentials: true,
          mode: "cors",
          headers: {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      );

      let responseData = await response.json();

      if (response.ok) {
        ToastUtil.success(responseData.message);
      } else {
        ToastUtil.error(responseData.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    if (!sites?.length) return;

    if (!selectedSiteId) {
      const storedSiteId = Number(localStorage.getItem("default_site_id"));
      const initialSiteId =
        sites.find((site) => site.id === storedSiteId)?.id || sites[0].id;
      setSelectedSiteId(initialSiteId);
      setPendingSiteId(initialSiteId);
      return;
    }

    defaultSiteHandler();
  }, [sites, selectedSiteId]);

  React.useEffect(() => {
    fetchScheduledNotification();
  }, []);

  useEffect(() => {
    fetchRollCalls();
  }, [activeSite]);

  const defaultSiteHandler = () =>
    setDefaultSiteData(sites.find((site) => site.id === selectedSiteId));

  const openSiteEditor = () => {
    setPendingSiteId(selectedSiteId);
    setIsEditingSite(true);
  };

  const applySiteSelection = () => {
    const nextSiteId = Number(pendingSiteId);
    const nextSite = sites.find((site) => site.id === nextSiteId);

    if (!nextSite) return;

    localStorage.setItem("default_site_id", `${nextSiteId}`);
    setSelectedSiteId(nextSiteId);
    setDefaultSiteData(nextSite);
    setIsEditingSite(false);
    ToastUtil.success(`Current site changed to ${nextSite.name}.`);
  };

  const nextMonthHandler = () =>
    setActiveMonth({
      startDate: moment(activeMonth.startDate).add(1, "month").startOf("month"),
      endDate: moment(activeMonth.endDate).add(1, "month").endOf("month"),
    });

  const previousMonthHandler = () =>
    setActiveMonth({
      startDate: moment(activeMonth.startDate).subtract(1, "month").startOf("month"),
      endDate: moment(activeMonth.endDate).subtract(1, "month").endOf("month"),
    });

  return (
    <React.Fragment>
      <section className="dashboard-hero">
        <div
          className="dashboard-hero__orb dashboard-hero__orb--one"
          aria-hidden="true"
        />
        <div
          className="dashboard-hero__orb dashboard-hero__orb--two"
          aria-hidden="true"
        />
        <div className="home-wrapper">
          <Jumbotron client={client} />
        </div>
        <div className="dashboard-site-card">
          <span className="dashboard-site-card__icon" aria-hidden="true">
            <i className="fas fa-location-dot" />
          </span>
          <div>
            <span className="dashboard-site-card__label">Current worksite</span>
            <h5>{defaultSiteData?.name || "Loading site..."}</h5>
            {sites.length > 1 && !isEditingSite && (
              <button
                type="button"
                className="dashboard-site-card__change"
                onClick={openSiteEditor}
              >
                <i className="fas fa-pen" aria-hidden="true" />
                Change site
              </button>
            )}
          </div>
          {sites.length > 1 && isEditingSite && (
            <div className="dashboard-site-card__editor">
              <label htmlFor="dashboard-site-select">Select worksite</label>
              <select
                id="dashboard-site-select"
                value={pendingSiteId || ""}
                onChange={(event) => setPendingSiteId(Number(event.target.value))}
              >
                {sites.map((site) => (
                  <option key={site.id} value={site.id}>
                    {site.name}
                  </option>
                ))}
              </select>
              <div className="dashboard-site-card__editor-actions">
                <button type="button" onClick={() => setIsEditingSite(false)}>
                  Cancel
                </button>
                <button type="button" onClick={applySiteSelection}>
                  Apply
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
      <div className="dashboard-content">
        <Announcement t={t} />
        <section className="dashboard-section" aria-labelledby="quick-actions-title">
          <div className="dashboard-section__heading">
            <div>
              <span className="dashboard-section__eyebrow">Workspace</span>
              <h2 id="quick-actions-title">Quick actions</h2>
            </div>
            <p>Your frequently used tools, one tap away.</p>
          </div>
          <Shortcuts client={client} defaultSiteData={defaultSiteData} t={t} />
        </section>
        {client && client.enable_smart_scheduler === true && activeSite && (
          <section className="dashboard-section dashboard-schedule-section">
            <MonthControl
              activeMonth={activeMonth}
              nextMonth={nextMonthHandler}
              previousMonth={previousMonthHandler}
              t={t}
            />
            <MonthSchedule
              client={client}
              sites={sites}
              activeMonth={activeMonth}
              activeSite={activeSite}
              t={t}
            />
          </section>
        )}
      </div>
    </React.Fragment>
  );
};

export default Home;
